import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "rootElement",
  class: "cadastral-map-container"
}
const _hoisted_2 = { class: "map-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "zoom-prompt-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LControlLayers = _resolveComponent("LControlLayers")!
  const _component_MapyCzBasicLayer = _resolveComponent("MapyCzBasicLayer")!
  const _component_MapyCzOrthoPhotoLayer = _resolveComponent("MapyCzOrthoPhotoLayer")!
  const _component_LControlZoom = _resolveComponent("LControlZoom")!
  const _component_LControl = _resolveComponent("LControl")!
  const _component_LGeoJson = _resolveComponent("LGeoJson")!
  const _component_LMap = _resolveComponent("LMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LMap, {
        center: _ctx.centerLatLng,
        zoom: _ctx.zoom,
        options: _ctx.mapOptions,
        class: "cadastral-map",
        ref: "map",
        "onUpdate:zoom": _ctx.updateZoom,
        "onUpdate:bounds": _ctx.handleBoundsChange,
        onReady: _ctx.onMapReady
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LControlLayers, {
            position: "topright",
            onReady: _ctx.onLayersControlReady
          }, null, 8, ["onReady"]),
          _createVNode(_component_MapyCzBasicLayer),
          _createVNode(_component_MapyCzOrthoPhotoLayer, { visible: false }),
          _createVNode(_component_LControlZoom, { position: "topleft" }),
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_LControl, {
                key: 0,
                position: "bottomleft"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("div", { class: "map-spinner-control" }, [
                    _createElementVNode("div", {
                      class: "spinner-border spinner-border-sm",
                      role: "status"
                    })
                  ], -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.cadastralUnitsFeatureCollection.features.length > 0)
            ? (_openBlock(), _createBlock(_component_LGeoJson, {
                key: `cadastral-units-${_ctx.zoom}`,
                geojson: _ctx.cadastralUnitsFeatureCollection,
                options: _ctx.geoJsonOptions,
                "options-style": _ctx.geoJsonStyleFunction
              }, null, 8, ["geojson", "options", "options-style"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["center", "zoom", "options", "onUpdate:zoom", "onUpdate:bounds", "onReady"]),
      (_ctx.zoomTooSmall)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "zoom-prompt-message" }, " Pro zobrazení katastrálních území přibližte mapu ", -1)
          ]))]))
        : _createCommentVNode("", true)
    ])
  ], 512))
}